// extracted by mini-css-extract-plugin
export default {"mainUserNav":"UserNav_mainUserNav__HFF5T","nav":"UserNav_nav__T+zoo"};